// extracted by mini-css-extract-plugin
export default {"share":"aPe_a2yL"};